import { render, staticRenderFns } from "./changeRoom.vue?vue&type=template&id=68854cd2&scoped=true&"
import script from "./changeRoom.vue?vue&type=script&lang=js&"
export * from "./changeRoom.vue?vue&type=script&lang=js&"
import style0 from "./changeRoom.vue?vue&type=style&index=0&id=68854cd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68854cd2",
  null
  
)

export default component.exports